exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".large_icon[data-v-1a3f0c2f]{font-size:12em}", ""]);

// exports
